export const base64ToBlob: any = (base64: string, type: string = 'application/octet-stream') => {
  const binStr = atob(base64);
  const len = binStr.length;
  const arr = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    arr[i] = binStr.charCodeAt(i);
  }
  return new Blob([arr], { type: type });
};
// Utility function to handle local storage operations
export const setLocalStorageItems = (items: Record<string, any>) => {
  Object.entries(items).forEach(([key, value]) => {
    if (value === null || value === undefined) {
      localStorage.removeItem(key);
    } else {
      localStorage.setItem(key, String(value)); // Convert value to a string
    }
  });
};
export const sortByField = (field: string) => (rowA: any, rowB: any) => {
  const nameA = String(rowA.values[field])?.trim().toLowerCase() || '';
  const nameB = String(rowB.values[field])?.trim().toLowerCase() || '';
  const isAlphaA = /^[a-z]/.test(nameA);
  const isAlphaB = /^[a-z]/.test(nameB);

  if (isAlphaA && !isAlphaB) return -1;
  if (!isAlphaA && isAlphaB) return 1;
  return nameA.localeCompare(nameB);
};
